import React, { Component } from 'react';
import Main from './main';
import { Layout, Button } from 'antd';
import { geekblue } from '@ant-design/colors';

import Logo from './logo'
import './App.less';

const { Content, Footer } = Layout


const styles = {
    header: {
        background: geekblue[5],
        textAlign: 'center',
    },
    content: {
        background: 'white',

    },
    padding: {
        padding: '24px'
    }
}

class App extends Component {
    render() {
        return (

            <div className={'container'}>
                <header style={{ ...styles.header, ...styles.padding }}>
                    <Logo/>
                </header>
            <Content style={{ ...styles.content, ...styles.padding }}>
                <Main />
            </Content>
            <Footer style={styles.padding}>
                Made with Ant Design <Button 
                type='link'
                arget='_blank' 
                referrerPolicy='no-referer' 
                href='https://www.buchi.la/posts/jinyong-ipsum'>
                    了解更多
                    </Button>
            </Footer>
            </div >
        );
    }
}

export default App;
